<template>
  <div>
    <!-- Filtro e Ações -->
    <div style="display: flex; justify-content: end; align-items: center; margin-top: -0.5rem">
      <div class="md-layout-item md-size-40" style="padding-left: 0">
        <md-field>
          <label>CPT</label>
        </md-field>
      </div>
    </div>

    <div style="margin-top: -2rem">
      <md-card id="cpt-codes" align="left">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <i class="material-icons">list_alt</i>
          </div>
          <h4 class="title">CPT Codes</h4>

          <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
            <div class="md-layout md-gutter md-layout-item md-size-20">
              <md-field class="md-sm">
                <label>Search</label>
                <md-input v-model="searchQuery" @keyup.enter="handleSearch" />
              </md-field>
            </div>
            <div v-if="organizations.length > 2" class="md-layout-item md-size-20">
              <md-field>
                <label for="currentType">Organization</label>
                <md-select v-model="currentOrganization" name="organization">
                  <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                    {{ type.label }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout md-gutter md-layout-item md-size-10">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
              </md-button>
            </div>
            <div class="md-layout md-gutter md-layout-item md-alignment-center-right" :class="[
              { 'md-size-50': organizations.length > 1 },
              { 'md-size-70': organizations.length <= 1 }
            ]">
              <md-button :disabled="isLoading" class="md-icon-button md-primary" @click="handleAdd">
                <md-icon>add</md-icon>
                <md-tooltip md-direction="bottom">Add new CPT</md-tooltip>
              </md-button>
              <md-button :disabled="isLoading" class="md-icon-button" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
              </md-button>
            </div>
          </div>
        </md-card-header>

        <md-card-content style="padding-top: 0px">
          <md-table v-if="!isLoading" :value="tableData" class="table-shopping table-striped table-hover">
            <md-table-row v-if="tableData.length === 0">
              <md-table-empty-state :md-description="`No CPT codes found for this time frame or search criteria`"
                md-label="No CPT codes found"></md-table-empty-state>
            </md-table-row>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Code">{{ item.code }}</md-table-cell>
              <md-table-cell md-label="Description">{{ item.description }}</md-table-cell>
              <md-table-cell md-label="FEE">{{ formatUSD(item.fee) }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button class="md-icon-button md-primary" @click="handleEdit(item)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit CPT</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <hr v-if="!isLoading" />
          <div v-if="!isLoading" style="display: flex; align-items: center">
            <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
              <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
                <i class="fas fa-angle-double-left" />
              </a>
              <span class="page-link"
                style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
                }}</span>
              <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
                <i class="fas fa-angle-double-right" />
              </a>
            </div>
            <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
              <div class="text-right">
                <p class="card-category">
                  Showing from
                  <b><u>{{ startCpt }}</u></b>
                  to
                  <b><u>{{ endCpt }}</u></b>. Total of
                  <b><u>{{ totalCptCodes }}</u></b>
                  CPT codes.
                </p>
              </div>
            </div>
            <md-field style="flex: 1; margin-top: 1.5rem">
              <label for="pages">Per page</label>
              <md-select v-model="pagination.perPage" name="pages">
                <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </md-card-content>
      </md-card>

      <loader :is-visible="isLoading" />

      <register-cpt-code v-if="showCptModal" :is-edit="isEdit" :is-modal="true" :current-cpt="currentCpt"
        @close="handleCloseModal" :org-id="currentOrganization" class="custom-dialog" />

    </div>
  </div>
</template>


<script>
import loader from "@/components/GlobeChek/loader.vue"
import cptService from "../../../../../services/cpt-service";
import registerCptCode from "../Pages/cptDetailsModal.vue"

export default {
  name: "ManageCPT",
  components: {
    loader,
    registerCptCode
  },
  data() {
    return {
      allCpts: [],
      filteredCpts: [],
      tableData: [],
      searchQuery: "",
      organizations: [
        ...JSON.parse(sessionStorage.getItem("organizations")).map((i) => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        })
      ],
      currentOrganization: [...JSON.parse(sessionStorage.getItem("organizations")).map((i) => {
        return {
          label: i.orgName,
          value: i.orgId
        }
      })
      ][0].value,
      isLoading: false,
      showCptModal: false,
      isEdit: false,
      currentCpt: null,
      limit: 10,
      offset: 0,
      pagination: {
        perPage: 10,
        perPageOptions: [10, 20, 50],
      },
      totalCptCodes: 0,
    };
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.sliceCpts()
    },
  },
  computed: {
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredCpts.length
    },
    startCpt() {
      return this.offset + 1
    },
    endCpt() {
      return Math.min(this.offset + this.limit, this.filteredCpts.length) || 1
    },
  },
  mounted: function () {
    this.handleRefresh();
  },
  methods: {
    sliceCpts() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredCpts)).slice(this.offset, this.offset + this.limit)
    },
    updateLimit(newLimit) {
      this.offset = 0
      this.sliceCpts()
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.sliceCpts()
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.sliceCpts()
      }
    },
    handleSearch() {
      const searchFilter = this.currentSearchTxt
      const orgFilter = this.currentOrganization
      let response = JSON.parse(JSON.stringify(this.allCpts))
      if (searchFilter) {
        response = response.filter((i) => {
          const searchText = (
            (i.code || "") +
            (i.description || "")
          ).toLowerCase()
          return searchText.includes(searchFilter.toLowerCase())
        })
      }
      if (orgFilter != "all") {
        response = response.filter((i) => i.orgId === orgFilter)
      }
      this.filteredCpts = response
      this.totalCptCodes = response.length
      this.offset = 0
      this.sliceCpts()
    },
    handleAdd() {
      this.isEdit = false;
      this.currentCpt = null;
      this.showCptModal = true;
    },
    handleEdit(item) {
      this.currentCpt = item;
      this.isEdit = true;
      this.showCptModal = true;
    },
    handleCloseModal(refresh) {
      this.showCptModal = false;
      if (refresh) {
        this.handleRefresh();
      }
    },
    async handleRefresh() {
      try {
        this.isLoading = true;
        const response = await cptService.getCPTAdminList();
        this.allCpts = response.data.items;
        this.totalCptCodes = response.data.total;
        this.handleSearch()
      } catch (error) {
        console.error("Error loading CPT codes:", error);
        this.$notify({
          message: "Error loading CPTs list. Please try again later",
          type: "danger"
        });
      } finally {
        this.isLoading = false;
      }
    },
    formatUSD(value) {
      if (value === undefined || value === null) return '-';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    },
  }
}
</script>

<style lang="scss" scoped>
.changing-password {
  clip-path: inset(0 1ch 0 0);
  animation: l 1s steps(4, jump-none) infinite;
}

@keyframes l {
  to {
    clip-path: inset(0)
  }
}

#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-phone {
    text-align: left;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.mmodal-container {
  max-width: 70vw;
  max-height: 75vh !important;
  overflow: auto;

  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination-container span {
  margin: 0 15px;
}

.custom-dialog {
  max-width: 450px;
  width: 100%;
}

@media (max-width: 640px) {
  .custom-dialog {
    max-width: 95vw;
  }
}
</style>